import MyTimesheetTeamCalendar from "../components/MyTimesheetTeamCalendar";
import useMyTimesheetTeamCalendar from "../hooks/useMyTimesheetTeamCalendar";

const MyTimesheetTeamCalendarPage = () => {
    const useMyTimesheetTeamCalendarProps = useMyTimesheetTeamCalendar();

    return <MyTimesheetTeamCalendar {...useMyTimesheetTeamCalendarProps} />
}

export default MyTimesheetTeamCalendarPage;